/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable array-callback-return */
import React, { PureComponent, Fragment } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';

import StoreLeftMenu from '../menu/StoreLeftMenu';
import Footer from '../components/Footer';

import axios from 'axios';
//import Modal from "react-responsive-modal";

//import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
//import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
import moment from 'moment';
//import {Helmet} from "react-helmet";

import OriginalGoods from '../containers/store/OriginalGoods';
import StoreIntro from '../containers/store/StoreIntro';

import ColraboCafeItem from '../components/store/ColraboCafeItem';
import NaverBlogItem from '../components/store/NaverBlogItem';
import StoreStoryItem from '../components/store/StoreStoryItem';
import TwitterItem from '../components/store/TwitterItem';
import EventItem from '../components/store/EventItem';

//import Slider from "react-slick";

import 'moment/locale/ko';
import $ from 'jquery';
import '../stick-kit.js';

import { Helmet } from 'react-helmet-async';

class Store extends PureComponent {
  state = {
    allList: [],
    leftTopList: [],
    rightBottomList: [],
    storeStoryList: [],
    blogList: [],
  };
  _isLoad = false;
  componentDidMount = () => {
    this._isLoad = true;
    window.scrollTo(0, 0);

    setTimeout(() => {
      $('.big_item .inner_item').stick_in_parent({
        parent: '.store_card_list',
      });
    }, 2500);

    window.onload = function () {
      $('.big_item .inner_item').stick_in_parent({
        parent: '.store_card_list',
      });
    };

    this._getStoreStory();
    this._getColraboBanner();
    this._getBlog();

    this._getEventBanner();
    // this._getTwitter();

    window.addEventListener('popstate', (event) => {
      //alert(0)
      setTimeout(() => {
        $('.big_item .inner_item').stick_in_parent({
          parent: '.store_card_list',
        });
      }, 1000);
    });
  };
  componentWillUnmount = () => {
    this._isLoad = false;
  };
  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    ////console.log(this.props.location.pathname)
    ////console.log(nextProps.location)
    return this.props !== nextProps;
    //return true;
  };
  componentWillReceiveProps = (nextProps) => {
    //console.log(this.props.match.params.store)
    //console.log(nextProps.match.params.store)
    if (this.props !== nextProps) {
      //alert(2)
    }
  };

  _getStoreStory = async () => {
    //const { allList } = this.state;
    const result = await this._getStoreStoryApi();
    const intReturn = result.data[0].intReturn;
    const storeStoryList = result.data[0].listData;
    //console.log(storeStoryList)
    if (intReturn === 0) {
      //allList.concat(storeStoryList)
      this.setState({
        rightBottomList: this.state.rightBottomList.concat(storeStoryList),
        storeStoryList,
      });
    }
  };
  _getStoreStoryApi = () => {
    const { apiUrl, loginId } = this.props;
    return axios
      .post(apiUrl + '/mainStoreStory', {
        params: {
          shop: 'main',
          loginId: loginId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };
  _getBlog = async () => {
    //const { allList } = this.state;
    const result = await this._getBlogApi();
    const intReturn = result.data[0].intReturn;
    const blogList = result.data[0].listData;
    //console.log(blogList)
    if (intReturn === 0) {
      //allList.concat(blogList)

      blogList.map((item, index) => {
        item.gubun = 'blog';
      });
      //console.log(blogList)

      if (this._isLoad) {
        this.setState({
          rightBottomList: this.state.rightBottomList.concat(blogList),
          blogList,
        });
      }
    }
  };
  _getBlogApi = () => {
    const { apiUrl } = this.props;
    return axios
      .post(apiUrl + '/getNaverBlog', {
        params: {},
      })
      .then((response) => response)
      .catch((error) => {
        // alert('오류가 발생했습니다.');
      });
  };
  _getTwitter = async () => {
    //const { allList } = this.state;
    const result = await this._getTwitterApi();

    //const result = await this._getBlogApi()

    const intReturn = result.data[0].intReturn;
    const twitterList = result.data[0].listData;
    //console.log(twitterList)
    if (intReturn === 0) {
      //allList.concat(blogList)

      twitterList.map((item, index) => {
        item.gubun = 'twitter';
        //item.gubun = 'blog'
        item.postdate = moment(new Date(item.createat)).format('YYYYMMDD');
      });
      //console.log(twitterList)
      if (this._isLoad) {
        this.setState({
          //allList: this.state.allList.concat(twitterList),
          leftTopList: this.state.leftTopList.concat(twitterList),
          twitterList,
        });
      }
    }
  };
  _getTwitterApi = () => {
    const { apiUrl } = this.props;
    //return axios.post(apiUrl + '/getTwitter', {
    return axios
      .post(apiUrl + '/getTwitterLocal', {
        params: {
          store: 'all',
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert('오류가 발생했습니다.');
      });
  };

  _getColraboBanner = async (store) => {
    //collabo
    //const { match } = this.props;
    //const store = match.params.store;

    const result = await this._getColraboBannerApi(store);
    const intReturn = result.data[0].intReturn;
    const colraboBannerList = result.data[0].listData;

    if (intReturn === 0) {
      if (this._isLoad) {
        this.setState({
          colraboBannerList,
        });
      }
    }
  };
  _getColraboBannerApi = (store) => {
    const { apiUrl, loginId } = this.props;

    return axios
      .post(apiUrl + '/storeCollaboBannerNew', {
        params: {
          shop: 'hapjung',
          userid: loginId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert('오류가 발생했습니다.');
      });
  };

  /*
    _getColraboBanner = async () => {
        //collabo

        const result = await this._getColraboBannerApi()
        const intReturn = result.data[0].intReturn
        const colraboBannerList = result.data[0].listData;

        if(intReturn === 0) {
            this.setState({
                colraboBannerList
            })
        }
    }
    _getColraboBannerApi = () => {
        const { apiUrl } = this.props;

        return axios.post(apiUrl + '/shopColraboBanner', {
            params: {
            }
        }) 
        .then(response => response)
        .catch(error => {
            alert('오류가 발생했습니다.')
        })
    }
    */
  _getEventBanner = async () => {
    //collabo

    const result = await this._getEventBannerApi();
    const intReturn = result.data[0].intReturn;
    const eventBannerList = result.data[0].listData;

    if (intReturn === 0) {
      if (this._isLoad) {
        this.setState({
          leftTopList: this.state.leftTopList.concat(eventBannerList),
          eventBannerList,
        });
      }
    }
  };
  _getEventBannerApi = () => {
    const { apiUrl } = this.props;

    return axios
      .post(apiUrl + '/shopEventBanner', {
        params: {},
      })
      .then((response) => response)
      .catch((error) => {
        // alert('오류가 발생했습니다.');
      });
  };
  _goStoreInfo = () => {
    const { history } = this.props;

    history.push('/storeInfo');
  };
  _goStoryWrite = () => {
    const { history } = this.props;

    history.push('/storeWrite');
  };
  _renderBottomItem = () => {
    const { rightBottomList } = this.state;

    rightBottomList.sort(function (a, b) {
      return b.postdate - a.postdate;
    });

    /*gubun에 따라 컴포넌트 분기 시킬것!*/

    const list = rightBottomList.map((item, index) => {
      if (item.gubun === 'blog') {
        return (
          <NaverBlogItem
            key={index}
            gubun={item.gubun}
            bloggerlink={item.bloggerlink}
            bloggername={item.bloggername}
            description={item.description}
            link={item.link}
            postdate={item.postdate}
            title={item.title}
          />
        );
      } else if (item.gubun === 'story') {
        return (
          <StoreStoryItem
            key={index}
            gubun={item.gubun}
            idx={item.idx}
            id={item.id}
            storeName={item.storeName}
            categoryName={item.categoryName}
            title={item.title}
            readnum={item.readnum}
            chuchon={item.chuchon}
            likes={item.likes}
            comment_num={item.comment_num}
            writeday={item.writeday}
            filename={item.filename}
            content={item.content}
            active={item.active}
          />
        );
      } else if (item.gubun === 'twitter') {
        return (
          <TwitterItem
            key={index}
            gubun={item.gubun}
            id={item.id}
            postdate={item.postdate}
            //source={item.source}
            text={item.text}
            media={item.media}
          />
        );
      } else if (item.gubun === 'event') {
        return (
          <EventItem
            key={index}
            idx={item.idx}
            bannerFile={item.bannerFile}
            LinkURL={item.LinkURL}
            Linktarget={item.Linktarget}
            title={item.title}
            comment={item.comment}
            banner={item.banner}
            LinkUrl_M={item.LinkUrl_M}
            Linktarget_M={item.Linktarget_M}
            adComIdx={item.adComIdx}
            pageCode={item.pageCode}
            gubun={item.gubun}
            comment_count={item.comment_count}
            openDay={item.openDay}
          />
        );
      }
    });
    return list;
  };

  _randerBlogItem = () => {
    const { blogList } = this.state;
    blogList.sort(function (a, b) {
      return b.postdate - a.postdate;
    });

    const list = blogList.map((item, index) => {
      return (
        <NaverBlogItem
          key={index}
          gubun={item.gubun}
          bloggerlink={item.bloggerlink}
          bloggername={item.bloggername}
          description={item.description}
          link={item.link}
          postdate={item.postdate}
          title={item.title}
        />
      );
    });

    return list;
  };

  _renderStoreItem = () => {
    const { storeStoryList } = this.state;
    storeStoryList.sort(function (a, b) {
      return b.postdate - a.postdate;
    });

    const list = storeStoryList.map((item, index) => {
      return (
        <StoreStoryItem
          key={index}
          gubun={item.gubun}
          idx={item.idx}
          id={item.id}
          storeName={item.storeName}
          categoryName={item.categoryName}
          title={item.title}
          readnum={item.readnum}
          chuchon={item.chuchon}
          likes={item.likes}
          comment_num={item.comment_num}
          writeday={item.writeday}
          filename={item.filename}
          content={item.content}
          active={item.active}
        />
      );
    });

    return list;
  };

  _renderLeftItem = () => {
    const { leftTopList } = this.state;

    leftTopList.sort(function (a, b) {
      return b.postdate - a.postdate;
    });

    /*gubun에 따라 컴포넌트 분기 시킬것!*/

    const list = leftTopList.map((item, index) => {
      if (item.gubun === 'blog') {
        return (
          <NaverBlogItem
            key={index}
            gubun={item.gubun}
            bloggerlink={item.bloggerlink}
            bloggername={item.bloggername}
            description={item.description}
            link={item.link}
            postdate={item.postdate}
            title={item.title}
          />
        );
      } else if (item.gubun === 'story') {
        return (
          <StoreStoryItem
            key={index}
            gubun={item.gubun}
            idx={item.idx}
            id={item.id}
            storeName={item.storeName}
            categoryName={item.categoryName}
            title={item.title}
            readnum={item.readnum}
            chuchon={item.chuchon}
            likes={item.likes}
            comment_num={item.comment_num}
            writeday={item.writeday}
            filename={item.filename}
            content={item.content}
            active={item.active}
          />
        );
      } else if (item.gubun === 'twitter') {
        return (
          <TwitterItem
            key={index}
            gubun={item.gubun}
            id={item.id}
            postdate={item.postdate}
            //source={item.source}
            text={item.text}
            media={item.media}
          />
        );
      } else if (item.gubun === 'event') {
        return (
          <EventItem
            key={index}
            idx={item.idx}
            bannerFile={item.bannerFile}
            LinkURL={item.LinkURL}
            Linktarget={item.Linktarget}
            title={item.title}
            comment={item.comment}
            banner={item.banner}
            LinkUrl_M={item.LinkUrl_M}
            Linktarget_M={item.Linktarget_M}
            adComIdx={item.adComIdx}
            pageCode={item.pageCode}
            gubun={item.gubun}
            comment_count={item.comment_count}
            openDay={item.openDay}
          />
        );
      }
    });
    return list;
  };

  _renderAllItem = () => {
    const { allList } = this.state;

    allList.sort(function (a, b) {
      return b.postdate - a.postdate;
    });

    /*gubun에 따라 컴포넌트 분기 시킬것!*/

    const list = allList.map((item, index) => {
      if (item.gubun === 'blog') {
        return (
          <NaverBlogItem
            key={index}
            gubun={item.gubun}
            bloggerlink={item.bloggerlink}
            bloggername={item.bloggername}
            description={item.description}
            link={item.link}
            postdate={item.postdate}
            title={item.title}
          />
        );
      } else if (item.gubun === 'story') {
        return (
          <StoreStoryItem
            key={index}
            gubun={item.gubun}
            idx={item.idx}
            id={item.id}
            storeName={item.storeName}
            categoryName={item.categoryName}
            title={item.title}
            readnum={item.readnum}
            chuchon={item.chuchon}
            likes={item.likes}
            comment_num={item.comment_num}
            writeday={item.writeday}
            filename={item.filename}
            content={item.content}
            active={item.active}
          />
        );
      } else if (item.gubun === 'twitter') {
        return (
          <TwitterItem
            key={index}
            gubun={item.gubun}
            id={item.id}
            postdate={item.postdate}
            //source={item.source}
            text={item.text}
            media={item.media}
          />
        );
      } else if (item.gubun === 'event') {
        return (
          <EventItem
            idx={item.idx}
            bannerFile={item.bannerFile}
            LinkURL={item.LinkURL}
            Linktarget={item.Linktarget}
            title={item.title}
            comment={item.comment}
            banner={item.banner}
            LinkUrl_M={item.LinkUrl_M}
            Linktarget_M={item.Linktarget_M}
            adComIdx={item.adComIdx}
            pageCode={item.pageCode}
            gubun={item.gubun}
            comment_count={item.comment_count}
            postdate={item.postdate}
          />
        );
      }
    });
    return list;
  };
  _renderBanner = () => {
    const { colraboBannerList } = this.state;

    const list = colraboBannerList.map((item, index) => {
      return (
        <ColraboCafeItem
          key={index}
          idx={item.idx}
          bannerFile={item.bannerFile}
          LinkURL={item.LinkURL}
          Linktarget={item.Linktarget}
          title={item.title}
          comment={item.comment}
          image={item.image}
          LinkUrl_M={item.LinkUrl_M}
          Linktarget_M={item.Linktarget_M}
          adComIdx={item.adComIdx}
          pageCode={item.pageCode}
          openDay={item.openDay}
          openDay1={item.openDay1}
          pos={'main'}
        />
      );
    });

    return list;
  };
  render() {
    const {
      colraboBannerList,

      leftTopList,
      rightBottomList,
      storeStoryList,
      blogList,
    } = this.state;

    return (
      <Fragment>
        <Helmet>
          <title>직영점 소개 - 애니플러스</title>
          <meta name="title" content="직영점 소개 - 애니플러스<" />
          <meta
            name="description"
            content="합정, 대전, 광주 부산 직영 샾 - 스파이 패밀리, 진격의 거인, 주술회전등 굿즈판매"
          />
          <meta name="robots" content="index,follow" />
          <meta
            name="keywords"
            content="굿즈판매, 애니플러스, 스파이 패밀리, 진격의 거인, 주술회전, 한일동시방영, 애니메이션"
          />

          <meta property="og:type" content="website" />
          <meta property="og:title" content="직영점 소개 - 애니플러스<" />
          <meta
            property="og:description"
            content="굿즈판매, 애니플러스, 스파이 패밀리, 진격의 거인, 주술회전, 한일동시방영, 애니메이션"
          />
          <meta property="og:url" content="https://www.aniplustv.com/store" />

          <meta name="twitter:card" content="summary" />
          <meta name="twitter:title" content="직영점 소개 - 애니플러스<" />
          <meta
            name="twitter:description"
            content="굿즈판매, 애니플러스, 스파이 패밀리, 진격의 거인, 주술회전, 한일동시방영, 애니메이션"
          />
          <meta
            name="twitter:domain"
            content="https://www.aniplustv.com/store"
          />

          <link rel="canonical" href="https://www.aniplustv.com/store" />
        </Helmet>
        <div className="content">
          {/*좌측메뉴*/}
          <StoreLeftMenu />

          <div className="vod_list_right store_right">
            <div className="vod_list_group">
              <div className="store_wrap">
                {/*스토어 상단*/}
                <div className="store_header">
                  <h1>{moment(new Date()).format('MM월 DD일 dddd')}</h1>
                  <div className="store_top_link">
                    <a href="#link_news">매장 소식</a>
                    <a href="#link_original">오리지널 굿즈</a>
                    <a href="#link_store">매장 이야기</a>
                    <a href="#link_intro">매장 소개</a>
                  </div>
                </div>
                <div className="store_container">
                  {/* 매장 소식 */}
                  <a name="link_news"></a>
                  <div className="store_news" id="store_news">
                    <ul className="store_card_list">
                      <li className="store_card_item big_item">
                        {colraboBannerList ? (
                          colraboBannerList.length >= 0 ? (
                            <ColraboCafeItem
                              idx={colraboBannerList[0].idx}
                              bannerFile={colraboBannerList[0].bannerFile}
                              LinkURL={colraboBannerList[0].LinkURL}
                              Linktarget={colraboBannerList[0].Linktarget}
                              title={colraboBannerList[0].title}
                              comment={colraboBannerList[0].comment}
                              image={colraboBannerList[0].image}
                              LinkUrl_M={colraboBannerList[0].LinkUrl_M}
                              Linktarget_M={colraboBannerList[0].Linktarget_M}
                              adComIdx={colraboBannerList[0].adComIdx}
                              pageCode={colraboBannerList[0].pageCode}
                              openDay={colraboBannerList[0].openDay}
                              openDay1={colraboBannerList[0].openDay1}
                              pos={'main'}
                              likes={colraboBannerList[0].likes}
                              isLike={colraboBannerList[0].isLike}
                              comment_count={colraboBannerList[0].comment_count}
                              readNum={colraboBannerList[0].readNum}
                            />
                          ) : null
                        ) : null}
                      </li>

                      <li className="store_card_item sm_item">
                        <div className="inner_item">
                          {/* 카드 내용 (콜라보 카페 cafe, 서울 합정점 su_hj, 대전 중앙로점 dj_ja, 광주 충장로점 gj_cj, 부산 서면점 bs_sm) / */}
                          {/*eventBannerList ? eventBannerList.length >= 0 ? (
                                                       <EventItem 
                                                       
                                                            idx={eventBannerList[0].idx}
                                                            bannerFile={eventBannerList[0].bannerFile}
                                                            LinkURL={eventBannerList[0].LinkURL}
                                                            Linktarget={eventBannerList[0].Linktarget}
                                                            title={eventBannerList[0].title}
                                                            comment={eventBannerList[0].comment}
                                                            banner={eventBannerList[0].banner}
                                                            LinkUrl_M={eventBannerList[0].LinkUrl_M}
                                                            Linktarget_M={eventBannerList[0].Linktarget_M}
                                                            adComIdx={eventBannerList[0].adComIdx}
                                                            pageCode={eventBannerList[0].pageCode}
                                                            gubun={eventBannerList[0].gubun}
                                                            comment_count={eventBannerList[0].comment_count}
                                                            openDay={eventBannerList[0].openDay}
                                                            
                                                        />
                                                    ) : null : null*/}
                          {/* {leftTopList
                            ? leftTopList.length > 0
                              ? this._renderLeftItem()
                              : null
                            : null} */}
                          {storeStoryList
                            ? storeStoryList.length > 0
                              ? this._renderStoreItem()
                              : null
                            : null}

                          {/* 카드 내용 (콜라보 카페 cafe, 서울 합정점 su_hj, 대전 중앙로점 dj_ja, 광주 충장로점 gj_cj, 부산 서면점 bs_sm) / */}
                        </div>
                      </li>
                    </ul>
                  </div>

                  {/* 오리지널 굿즈 */}
                  <a name="link_original"></a>
                  <OriginalGoods />

                  {/* 매장이야기 */}
                  <a name="link_store"></a>
                  <div className="store_story" id="store_story">
                    <ul className="store_card_list">
                      <li className="store_card_item sm_item">
                        <div className="inner_item">
                          {/* 카드 내용 (콜라보 카페 cafe, 서울 합정점 su_hj, 대전 중앙로점 dj_ja, 광주 충장로점 gj_cj, 부산 서면점 bs_sm) / */}

                          {/* {rightBottomList ? this._renderBottomItem() : null} */}
                          {blogList ? this._randerBlogItem() : null}
                        </div>
                      </li>

                      <li className="store_card_item big_item">
                        <div className="inner_item">
                          {/* 카드 내용 (콜라보 카페 cafe, 서울 합정점 su_hj, 대전 중앙로점 dj_ja, 광주 충장로점 gj_cj, 부산 서면점 bs_sm) / */}
                          {colraboBannerList ? (
                            colraboBannerList.length >= 1 ? (
                              <ColraboCafeItem
                                idx={colraboBannerList[1].idx}
                                bannerFile={colraboBannerList[1].bannerFile}
                                LinkURL={colraboBannerList[1].LinkURL}
                                Linktarget={colraboBannerList[1].Linktarget}
                                title={colraboBannerList[1].title}
                                comment={colraboBannerList[1].comment}
                                image={colraboBannerList[1].image}
                                LinkUrl_M={colraboBannerList[1].LinkUrl_M}
                                Linktarget_M={colraboBannerList[1].Linktarget_M}
                                adComIdx={colraboBannerList[1].adComIdx}
                                pageCode={colraboBannerList[1].pageCode}
                                openDay={colraboBannerList[1].openDay}
                                openDay1={colraboBannerList[1].openDay1}
                                pos={'main'}
                                likes={colraboBannerList[1].likes}
                                isLike={colraboBannerList[1].isLike}
                                comment_count={
                                  colraboBannerList[1].comment_count
                                }
                                readNum={colraboBannerList[1].readNum}
                              />
                            ) : null
                          ) : null}
                        </div>
                      </li>
                    </ul>
                  </div>

                  {/* 매장소개 */}
                  <a name="link_intro"></a>
                  <StoreIntro />
                </div>
              </div>
            </div>

            <Footer />
          </div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(Store)));
